export const mockProducts = [
  {
    id: 1,
    name: 'ESKER FT 72L',
    status: 'OK',
    owner: {
      CardId: "56745635",
      name: 'Erik Svensson',
      address: 'Vikaholmsallén 43, 352 20 Växjö',
      phone: '070-123 45 67',
      email: 'erik.svensson@exempel.se'
    },
    notes: [
      { id: 1, text: 'Kontrollera filtret var tredje månad.', date: '2024-01-01 10:00:00' },
      { id: 2, text: 'Test test', date: '2024-02-01 12:00:00' }
    ],
    parameters: [
      {
        name: 'Temperatur',
        unit: '°C',
        data: [{ value: 22 }, { value: 22 }],
        historicalData: [
          { time: 'Jan', value: 10 },
          { time: 'Feb', value: 15 },
          { time: 'Mar', value: 19 },
          { time: 'Apr', value: 23 },
          { time: 'Maj', value: 20 },
          { time: 'Jun', value: 22 },
          { time: 'Jul', value: 40 },
          { time: 'Aug', value: 24 },
          { time: 'Sep', value: 25 },
          { time: 'Okt', value: 26 },
          { time: 'Nov', value: 27 },
          { time: 'Dec', value: 28 }
        ]
      },
      {
        name: 'pH-värde',
        unit: 'pH',
        data: [{ value: 7 }, { value: 7.2 }],
        historicalData: [
          { time: 'Jan', value: 7 },
          { time: 'Feb', value: 7.2 },
          { time: 'Mar', value: 7.5 },
          { time: 'Apr', value: 7.8 },
          { time: 'Maj', value: 7.9 },
          { time: 'Jun', value: 8.2 },
          { time: 'Jul', value: 8.5 },
          { time: 'Aug', value: 8.7 },
          { time: 'Sep', value: 8.9 },
          { time: 'Okt', value: 9.1 },
          { time: 'Nov', value: 9.3 },
          { time: 'Dec', value: 9.5 }
        ]
      },
      {
        name: 'Konduktivitet',
        unit: 'mS/m',
        data: [{ value: 90 }, { value: 94 }],
        historicalData: [
          { time: 'Jan', value: 83 },
          { time: 'Feb', value: 84 },
          { time: 'Mar', value: 65 },
          { time: 'Apr', value: 86 },
          { time: 'Maj', value: 77 },
          { time: 'Jun', value: 88 },
          { time: 'Jul', value: 89 },
          { time: 'Aug', value: 90 },
          { time: 'Sep', value: 91 },
          { time: 'Okt', value: 92 },
          { time: 'Nov', value: 93 },
          { time: 'Dec', value: 94 }
        ]
      },
      {
        name: 'Tryck',
        unit: 'bar',
        data: [{ value: 5 }, { value: 6 }],
        historicalData: [
          { time: 'Jan', value: 5 },
          { time: 'Feb', value: 4 },
          { time: 'Mar', value: 8 },
          { time: 'Apr', value: 5 },
          { time: 'Maj', value: 3 },
          { time: 'Jun', value: 9 },
          { time: 'Jul', value: 5 },
          { time: 'Aug', value: 6 },
          { time: 'Sep', value: 7 },
          { time: 'Okt', value: 8 },
          { time: 'Nov', value: 9 },
          { time: 'Dec', value: 10 }
        ]
      },
      {
        name: 'Redox',
        unit: 'mV',
        data: [{ value: 700 }, { value: 700 }],
        historicalData: [
          { time: 'Jan', value: 600 },
          { time: 'Feb', value: 700 },
          { time: 'Mar', value: 800 },
          { time: 'Apr', value: 600 },
          { time: 'Maj', value: 700 },
          { time: 'Jun', value: 800 },
          { time: 'Jul', value: 600 },
          { time: 'Aug', value: 700 },
          { time: 'Sep', value: 800 },
          { time: 'Okt', value: 600 },
          { time: 'Nov', value: 700 },
          { time: 'Dec', value: 800 }
        ]
      },
      {
        name: 'Flöde',
        unit: 'l/min',
        data: [{ value: 25 }, { value: 25 }],
        historicalData: [
          { time: 'Jan', value: 25 },
          { time: 'Feb', value: 23 },
          { time: 'Mar', value: 28 },
          { time: 'Apr', value: 27 },
          { time: 'Maj', value: 30 },
          { time: 'Jun', value: 31 },
          { time: 'Jul', value: 32 },
          { time: 'Aug', value: 30 },
          { time: 'Sep', value: 24 },
          { time: 'Okt', value: 25 },
          { time: 'Nov', value: 30 },
          { time: 'Dec', value: 32 }
        ]
      }
    ],
    reseller: {
      id: 1,
      name: 'ÅF1',
    },
    logs: []
  },
  {
    id: 2,
    name: 'ESKER FT 148L',
    status: 'Varning',
    owner: {
      CardId: "123123",
      name: 'Anna Larsson',
      address: 'Värendsgatan 65, 352 35 Växjö',
      phone: '072-234 56 78',
      email: 'anna.larsson@exempel.se'
    },
    notes: [
      { id: 1, text: 'Senaste underhåll 2023-05-10.', date: '2023-05-10 09:00:00' }
    ],
    parameters: [
      {
        name: 'Temperatur',
        unit: '°C',
        data: [{ value: 22 }, { value: 23 }],
        historicalData: [
          { time: 'Jan', value: 11 },
          { time: 'Feb', value: 16 },
          { time: 'Mar', value: 18 },
          { time: 'Apr', value: 22 },
          { time: 'Maj', value: 25 },
          { time: 'Jun', value: 22 },
          { time: 'Jul', value: 35 },
          { time: 'Aug', value: 36 },
          { time: 'Sep', value: 37 },
          { time: 'Okt', value: 38 },
          { time: 'Nov', value: 39 },
          { time: 'Dec', value: 40 }
        ]
      },
      {
        name: 'pH-värde',
        unit: 'pH',
        data: [{ value: 7 }, { value: 7.5 }],
        historicalData: [
          { time: 'Jan', value: 7 },
          { time: 'Feb', value: 7.1 },
          { time: 'Mar', value: 7.4 },
          { time: 'Apr', value: 7.8 },
          { time: 'Maj', value: 7.4 },
          { time: 'Jun', value: 8.1 },
          { time: 'Jul', value: 8.5 },
          { time: 'Aug', value: 8.6 },
          { time: 'Sep', value: 8.7 },
          { time: 'Okt', value: 8.8 },
          { time: 'Nov', value: 8.9 },
          { time: 'Dec', value: 9 }
        ]
      },
      {
        name: 'Konduktivitet',
        unit: 'mS/m',
        data: [{ value: 83 }, { value: 83 }],
        historicalData: [
          { time: 'Jan', value: 112 },
          { time: 'Feb', value: 99 },
          { time: 'Mar', value: 88 },
          { time: 'Apr', value: 69 },
          { time: 'Maj', value: 86 },
          { time: 'Jun', value: 73 },
          { time: 'Jul', value: 85 },
          { time: 'Aug', value: 86 },
          { time: 'Sep', value: 87 },
          { time: 'Okt', value: 88 },
          { time: 'Nov', value: 89 },
          { time: 'Dec', value: 90 }
        ]
      },
      {
        name: 'Tryck',
        unit: 'bar',
        data: [{ value: 5 }, { value: 6.2 }],
        historicalData: [
          { time: 'Jan', value: 4.5 },
          { time: 'Feb', value: 3.3 },
          { time: 'Mar', value: 6.5 },
          { time: 'Apr', value: 3.5 },
          { time: 'Maj', value: 8.2 },
          { time: 'Jun', value: 9.5 },
          { time: 'Jul', value: 10.1 },
          { time: 'Aug', value: 10.2 },
          { time: 'Sep', value: 10.3 },
          { time: 'Okt', value: 10.4 },
          { time: 'Nov', value: 10.5 },
          { time: 'Dec', value: 10.6 }
        ]
      },
      {
        name: 'Redox',
        unit: 'mV',
        data: [{ value: 700 }, { value: 700 }],
        historicalData: [
          { time: 'Jan', value: 600 },
          { time: 'Feb', value: 700 },
          { time: 'Mar', value: 800 },
          { time: 'Apr', value: 600 },
          { time: 'Maj', value: 700 },
          { time: 'Jun', value: 800 },
          { time: 'Jul', value: 600 },
          { time: 'Aug', value: 700 },
          { time: 'Sep', value: 800 },
          { time: 'Okt', value: 600 },
          { time: 'Nov', value: 700 },
          { time: 'Dec', value: 800 }
        ]
      },
      {
        name: 'Flöde',
        unit: 'l/min',
        data: [{ value: 25 }, { value: 25 }],
        historicalData: [
          { time: 'Jan', value: 25 },
          { time: 'Feb', value: 23 },
          { time: 'Mar', value: 28 },
          { time: 'Apr', value: 27 },
          { time: 'Maj', value: 30 },
          { time: 'Jun', value: 31 },
          { time: 'Jul', value: 32 },
          { time: 'Aug', value: 30 },
          { time: 'Sep', value: 24 },
          { time: 'Okt', value: 25 },
          { time: 'Nov', value: 30 },
          { time: 'Dec', value: 32 }
        ]
      }
    ],
    reseller: {
      id: 2,
      name: 'ÅF2',
    },
    logs: [
      { type: 'INFO', title: 'Backspolning slutfört', message: 'Programmet har körts färdigt', date: '2024-05-01 10:00:00' },
      { type: 'WARNING', title: 'pH-värde för lågt', message: 'Uppmätt pH värde ligger under gränsvärde, 3.2', date: '2024-05-03 14:00:00' },
      { type: 'ERROR', title: 'Slut i saltkärl', message: 'Saltet i saltbehållaren har tagit slut. Fyll på och kör programmet igen', date: '2024-05-05 08:00:00' }
    ]
  },
  {
    id: 3,
    name: 'ESKER FTC 148L',
    status: 'Offline',
    owner: {
      CardId: "321321",
      name: 'Lars Andersson',
      address: 'Fogdegatan 13, 352 36 Växjö',
      phone: '076-345 67 89',
      email: 'lars.andersson@exempel.se'
    },
    notes: [],
    parameters: [
      {
        name: 'Temperatur',
        unit: '°C',
        data: [{ value: 21 }, { value: 22 }],
        historicalData: [
          { time: 'Jan', value: 12 },
          { time: 'Feb', value: 14 },
          { time: 'Mar', value: 18 },
          { time: 'Apr', value: 21 },
          { time: 'Maj', value: 19 },
          { time: 'Jun', value: 23 },
          { time: 'Jul', value: 37 },
          { time: 'Aug', value: 38 },
          { time: 'Sep', value: 39 },
          { time: 'Okt', value: 40 },
          { time: 'Nov', value: 41 },
          { time: 'Dec', value: 42 }
        ]
      },
      {
        name: 'pH-värde',
        unit: 'pH',
        data: [{ value: 6.8 }, { value: 7.1 }],
        historicalData: [
          { time: 'Jan', value: 6.8 },
          { time: 'Feb', value: 7.0 },
          { time: 'Mar', value: 7.3 },
          { time: 'Apr', value: 7.6 },
          { time: 'Maj', value: 7.7 },
          { time: 'Jun', value: 7.9 },
          { time: 'Jul', value: 8.2 },
          { time: 'Aug', value: 8.3 },
          { time: 'Sep', value: 8.4 },
          { time: 'Okt', value: 8.5 },
          { time: 'Nov', value: 8.6 },
          { time: 'Dec', value: 8.7 }
        ]
      },
      {
        name: 'Konduktivitet',
        unit: 'mS/m',
        data: [{ value: 82 }, { value: 83 }],
        historicalData: [
          { time: 'Jan', value: 100 },
          { time: 'Feb', value: 73 },
          { time: 'Mar', value: 74 },
          { time: 'Apr', value: 93 },
          { time: 'Maj', value: 85 },
          { time: 'Jun', value: 73 },
          { time: 'Jul', value: 86 },
          { time: 'Aug', value: 87 },
          { time: 'Sep', value: 88 },
          { time: 'Okt', value: 89 },
          { time: 'Nov', value: 90 },
          { time: 'Dec', value: 91 }
        ]
      },
      {
        name: 'Tryck',
        unit: 'bar',
        data: [{ value: 4.5 }, { value: 5.5 }],
        historicalData: [
          { time: 'Jan', value: 4.5 },
          { time: 'Feb', value: 5.5 },
          { time: 'Mar', value: 6.5 },
          { time: 'Apr', value: 3.5 },
          { time: 'Maj', value: 8.5 },
          { time: 'Jun', value: 9.5 },
          { time: 'Jul', value: 10.5 },
          { time: 'Aug', value: 11.5 },
          { time: 'Sep', value: 12.5 },
          { time: 'Okt', value: 13.5 },
          { time: 'Nov', value: 14.5 },
          { time: 'Dec', value: 15.5 }
        ]
      },
      {
        name: 'Redox',
        unit: 'mV',
        data: [{ value: 700 }, { value: 700 }],
        historicalData: [
          { time: 'Jan', value: 600 },
          { time: 'Feb', value: 700 },
          { time: 'Mar', value: 800 },
          { time: 'Apr', value: 600 },
          { time: 'Maj', value: 700 },
          { time: 'Jun', value: 800 },
          { time: 'Jul', value: 600 },
          { time: 'Aug', value: 700 },
          { time: 'Sep', value: 800 },
          { time: 'Okt', value: 600 },
          { time: 'Nov', value: 700 },
          { time: 'Dec', value: 800 }
        ]
      },
      {
        name: 'Flöde',
        unit: 'l/min',
        data: [{ value: 25 }, { value: 25 }],
        historicalData: [
          { time: 'Jan', value: 25 },
          { time: 'Feb', value: 23 },
          { time: 'Mar', value: 28 },
          { time: 'Apr', value: 27 },
          { time: 'Maj', value: 30 },
          { time: 'Jun', value: 31 },
          { time: 'Jul', value: 32 },
          { time: 'Aug', value: 30 },
          { time: 'Sep', value: 24 },
          { time: 'Okt', value: 25 },
          { time: 'Nov', value: 30 },
          { time: 'Dec', value: 32 }
        ]
      }
    ],
    reseller: {
      id: 1,
      name: 'ÅF1',
    },
    logs: []
  },
  {
    id: 4,
    name: 'ESKER FT 72L',
    status: 'Varning',
    owner: {
      CardId: "764723",
      name: 'Katarina Johansson',
      address: 'Storgatan 23, 352 33 Växjö',
      phone: '073-210 55 67',
      email: 'katarina.johansson@exempel.se'
    },
    notes: [
      { id: 1, text: 'Regelbunden kontroll krävs.', date: '2024-03-01 15:00:00' }
    ],
    parameters: [
      {
        name: 'Temperatur',
        unit: '°C',
        data: [{ value: 19 }, { value: 21 }],
        historicalData: [
          { time: 'Jan', value: 7 },
          { time: 'Feb', value: 10 },
          { time: 'Mar', value: 14 },
          { time: 'Apr', value: 18 },
          { time: 'Maj', value: 21 },
          { time: 'Jun', value: 22 },
          { time: 'Jul', value: 30 },
          { time: 'Aug', value: 31 },
          { time: 'Sep', value: 32 },
          { time: 'Okt', value: 33 },
          { time: 'Nov', value: 34 },
          { time: 'Dec', value: 35 }
        ]
      },
      {
        name: 'pH-värde',
        unit: 'pH',
        data: [{ value: 6.9 }, { value: 7.1 }],
        historicalData: [
          { time: 'Jan', value: 6.8 },
          { time: 'Feb', value: 6.9 },
          { time: 'Mar', value: 7.2 },
          { time: 'Apr', value: 7.4 },
          { time: 'Maj', value: 7.6 },
          { time: 'Jun', value: 7.9 },
          { time: 'Jul', value: 8.1 },
          { time: 'Aug', value: 8.2 },
          { time: 'Sep', value: 8.3 },
          { time: 'Okt', value: 8.4 },
          { time: 'Nov', value: 8.5 },
          { time: 'Dec', value: 8.6 }
        ]
      },
      {
        name: 'Konduktivitet',
        unit: 'mS/m',
        data: [{ value: 94 }, { value: 95 }],
        historicalData: [
          { time: 'Jan', value: 90 },
          { time: 'Feb', value: 90 },
          { time: 'Mar', value: 90 },
          { time: 'Apr', value: 70 },
          { time: 'Maj', value: 90 },
          { time: 'Jun', value: 80 },
          { time: 'Jul', value: 100 },
          { time: 'Aug', value: 90 },
          { time: 'Sep', value: 80 },
          { time: 'Okt', value: 70 },
          { time: 'Nov', value: 90 },
          { time: 'Dec', value: 90 }
        ]
      },
      {
        name: 'Tryck',
        unit: 'bar',
        data: [{ value: 5 }, { value: 6 }],
        historicalData: [
          { time: 'Jan', value: 5 },
          { time: 'Feb', value: 5 },
          { time: 'Mar', value: 6 },
          { time: 'Apr', value: 6 },
          { time: 'Maj', value: 7 },
          { time: 'Jun', value: 7.5 },
          { time: 'Jul', value: 9 },
          { time: 'Aug', value: 9.5 },
          { time: 'Sep', value: 10 },
          { time: 'Okt', value: 10.5 },
          { time: 'Nov', value: 11 },
          { time: 'Dec', value: 11.5 }
        ]
      },
      {
        name: 'Redox',
        unit: 'mV',
        data: [{ value: 700 }, { value: 700 }],
        historicalData: [
          { time: 'Jan', value: 600 },
          { time: 'Feb', value: 700 },
          { time: 'Mar', value: 800 },
          { time: 'Apr', value: 600 },
          { time: 'Maj', value: 700 },
          { time: 'Jun', value: 800 },
          { time: 'Jul', value: 600 },
          { time: 'Aug', value: 700 },
          { time: 'Sep', value: 800 },
          { time: 'Okt', value: 600 },
          { time: 'Nov', value: 700 },
          { time: 'Dec', value: 800 }
        ]
      },
      {
        name: 'Flöde',
        unit: 'l/min',
        data: [{ value: 25 }, { value: 25 }],
        historicalData: [
          { time: 'Jan', value: 25 },
          { time: 'Feb', value: 23 },
          { time: 'Mar', value: 28 },
          { time: 'Apr', value: 27 },
          { time: 'Maj', value: 30 },
          { time: 'Jun', value: 31 },
          { time: 'Jul', value: 32 },
          { time: 'Aug', value: 30 },
          { time: 'Sep', value: 24 },
          { time: 'Okt', value: 25 },
          { time: 'Nov', value: 30 },
          { time: 'Dec', value: 32 }
        ]
      }
    ],
    reseller: {
      id: 1,
      name: 'ÅF1',
    },
    logs: [
      { type: 'INFO', title: 'Service', message: 'Det är dags för årlig service av systemet.', date: '2024-06-01 09:00:00' },
      { type: 'WARNING', title: 'Lågt vattenflöde', message: 'Vattenflödet har legat under den rekommenderade nivån de senaste dagarna.', date: '2024-06-05 11:00:00' },
      { type: 'ERROR', title: 'Pumpfel', message: 'Huvudpumpen har slutat fungera och behöver omedelbart underhåll.', date: '2024-06-10 07:30:00' }
    ]
  },
  {
    id: 5,
    name: 'ESKER FTC 148L',
    status: 'OK',
    owner: {
      CardId: "362879",
      name: 'Per Andersson',
      address: 'Södra Vägen 18, 352 44 Växjö',
      phone: '070-312 44 56',
      email: 'per.andersson@exempel.se'
    },
    notes: [
      { id: 1, text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', date: '2024-05-01 11:00:00' },
      { id: 2, text: 'Övervaka vattenflödet noga.', date: '2024-04-01 14:00:00' }
    ],
    parameters: [
      {
        name: 'Temperatur',
        unit: '°C',
        data: [{ value: 20 }, { value: 22 }],
        historicalData: [
          { time: 'Jan', value: 13 },
          { time: 'Feb', value: 15 },
          { time: 'Mar', value: 19 },
          { time: 'Apr', value: 23 },
          { time: 'Maj', value: 20 },
          { time: 'Jun', value: 22 },
          { time: 'Jul', value: 33 },
          { time: 'Aug', value: 34 },
          { time: 'Sep', value: 35 },
          { time: 'Okt', value: 36 },
          { time: 'Nov', value: 37 },
          { time: 'Dec', value: 38 }
        ]
      },
      {
        name: 'pH-värde',
        unit: 'pH',
        data: [{ value: 7 }, { value: 7.4 }],
        historicalData: [
          { time: 'Jan', value: 6.9 },
          { time: 'Feb', value: 7 },
          { time: 'Mar', value: 7.2 },
          { time: 'Apr', value: 7.5 },
          { time: 'Maj', value: 7.3 },
          { time: 'Jun', value: 7.7 },
          { time: 'Jul', value: 8.3 },
          { time: 'Aug', value: 8.4 },
          { time: 'Sep', value: 8.5 },
          { time: 'Okt', value: 8.6 },
          { time: 'Nov', value: 8.7 },
          { time: 'Dec', value: 8.8 }
        ]
      },
      {
        name: 'Konduktivitet',
        unit: 'mS/m',
        data: [{ value: 84 }, { value: 85 }],
        historicalData: [
          { time: 'Jan', value: 90 },
          { time: 'Feb', value: 80 },
          { time: 'Mar', value: 100 },
          { time: 'Apr', value: 110 },
          { time: 'Maj', value: 60 },
          { time: 'Jun', value: 70 },
          { time: 'Jul', value: 80 },
          { time: 'Aug', value: 90 },
          { time: 'Sep', value: 100 },
          { time: 'Okt', value: 110 },
          { time: 'Nov', value: 120 },
          { time: 'Dec', value: 130 }
        ]
      },
      {
        name: 'Tryck',
        unit: 'bar',
        data: [{ value: 4 }, { value: 5 }],
        historicalData: [
          { time: 'Jan', value: 5 },
          { time: 'Feb', value: 5 },
          { time: 'Mar', value: 6 },
          { time: 'Apr', value: 6 },
          { time: 'Maj', value: 7 },
          { time: 'Jun', value: 7.5 },
          { time: 'Jul', value: 9 },
          { time: 'Aug', value: 9.5 },
          { time: 'Sep', value: 10 },
          { time: 'Okt', value: 10.5 },
          { time: 'Nov', value: 11 },
          { time: 'Dec', value: 11.5 }
        ]
      },
      {
        name: 'Redox',
        unit: 'mV',
        data: [{ value: 700 }, { value: 700 }],
        historicalData: [
          { time: 'Jan', value: 600 },
          { time: 'Feb', value: 700 },
          { time: 'Mar', value: 800 },
          { time: 'Apr', value: 600 },
          { time: 'Maj', value: 700 },
          { time: 'Jun', value: 800 },
          { time: 'Jul', value: 600 },
          { time: 'Aug', value: 700 },
          { time: 'Sep', value: 800 },
          { time: 'Okt', value: 600 },
          { time: 'Nov', value: 700 },
          { time: 'Dec', value: 800 }
        ]
      },
      {
        name: 'Flöde',
        unit: 'l/min',
        data: [{ value: 25 }, { value: 25 }],
        historicalData: [
          { time: 'Jan', value: 25 },
          { time: 'Feb', value: 23 },
          { time: 'Mar', value: 28 },
          { time: 'Apr', value: 27 },
          { time: 'Maj', value: 30 },
          { time: 'Jun', value: 31 },
          { time: 'Jul', value: 32 },
          { time: 'Aug', value: 30 },
          { time: 'Sep', value: 24 },
          { time: 'Okt', value: 25 },
          { time: 'Nov', value: 30 },
          { time: 'Dec', value: 32 }
        ]
      }
    ],
    reseller: {
      id: 2,
      name: 'ÅF2',
    },
    logs: []
  },
];